export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.coupons = payload;

  return newState;
};
